import { Button } from '@/common/ui'
import { DialogFooter } from '@/common/ui/dialog'
import type { ResolvedApplicationFlowAction } from '../useApplicationFlowResolver'

type Props = {
    primaryAction?: ResolvedApplicationFlowAction
    secondaryAction?: ResolvedApplicationFlowAction
    onAction: (action?: ResolvedApplicationFlowAction) => void
    disabled?: boolean
}

export function ApplicationFlowActionFooter({ primaryAction, secondaryAction, onAction, disabled = false }: Props) {
    const hasSecondaryAction = Boolean(secondaryAction)

    return (
        <DialogFooter className="w-screen fixed bottom-0 left-0 right-0 z-40 bg-gradient-to-b from-white/10 via-transparent to-white/50 backdrop-blur-lg border-t border-white/10 sm:static sm:w-full sm:bg-transparent">
            {!hasSecondaryAction ? (
                <div className="w-full max-w-[600px] mx-auto mt-0 p-6 md:px-0 flex justify-end gap-3">
                    <div className="w-full md:w-auto">
                        {primaryAction && (
                            <Button
                                variant="secondary"
                                loading={disabled}
                                disabled={!primaryAction.enabled || disabled}
                                onClick={() => onAction(primaryAction)}
                                className="w-full md:w-auto h-[60px] px-6 disabled:bg-brand-dust-hover"
                            >
                                {primaryAction.label}
                            </Button>
                        )}
                    </div>
                </div>
            ) : (
                <div className="w-full max-w-[600px] mx-auto mt-0 p-6 md:px-0 flex items-center gap-5">
                    {secondaryAction && (
                        <div className="w-full md:w-auto">
                            <Button
                                variant="outline"
                                disabled={disabled}
                                onClick={() => onAction(secondaryAction)}
                                className="w-full h-[60px] px-6"
                            >
                                {secondaryAction.label}
                            </Button>
                        </div>
                    )}
                    {primaryAction && (
                        <div className="ml-auto w-full md:w-auto">
                            <Button
                                variant="secondary"
                                loading={disabled}
                                disabled={!primaryAction.enabled || disabled}
                                onClick={() => onAction(primaryAction)}
                                className="w-full h-[60px] px-6 disabled:bg-brand-dust-hover"
                            >
                                {primaryAction.label}
                            </Button>
                        </div>
                    )}
                </div>
            )}
        </DialogFooter>
    )
}
